"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Header = _interopRequireDefault(require("./Header"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/*
 * @Author: jerrykjia
 * @Date: 2021-05-27 20:00:00
 * @Last Modified by: jerrykjia
 */
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var DropdownCard = function DropdownCard(props) {
  var description = props.description,
    title = props.title,
    url = props.url,
    header = props.header,
    restProps = __rest(props, ["description", "title", "url", "header"]);
  var refsHeight = (0, _react.useRef)(null);
  var hoverRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var _a;
    if ((refsHeight === null || refsHeight === void 0 ? void 0 : refsHeight.current) && (hoverRef === null || hoverRef === void 0 ? void 0 : hoverRef.current)) {
      if (((_a = refsHeight === null || refsHeight === void 0 ? void 0 : refsHeight.current) === null || _a === void 0 ? void 0 : _a.clientHeight) === refsHeight.current.scrollHeight) {
        hoverRef.current.style.visibility = 'hidden';
      }
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement("article", __assign({
    className: "dropdown-card"
  }, restProps), header && /*#__PURE__*/_react["default"].createElement(_Header["default"], __assign({}, header)), /*#__PURE__*/_react["default"].createElement("a", {
    className: "content",
    href: url
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "title"
  }, title), /*#__PURE__*/_react["default"].createElement("summary", {
    ref: refsHeight,
    className: "body"
  }, description), /*#__PURE__*/_react["default"].createElement("button", {
    ref: hoverRef,
    className: "dropdown-btn",
    title: "dropdown button"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: "https://main.qcloudimg.com/qcintl-cms/154/1622119439624/829d95b02396a7983828136eb1979220.svg"
  }))));
};
var _default = exports["default"] = DropdownCard;